import { cn } from '../../lib/utils';

export default function SectionLabel({ children, tone = 'primary', className }) {
  const tones = {
    primary: 'bg-md-primary-container text-md-on-primary-container',
    secondary: 'bg-md-secondary-container text-md-on-secondary-container',
    neutral: 'bg-md-surface-container-high text-md-on-surface-variant',
  };
  return <div className={cn('inline-flex min-h-8 items-center rounded-full px-4 text-xs font-medium tracking-[0.01em]', tones[tone], className)}>{children}</div>;
}
